export default "__VITE_ASSET__zG1UaoQM__"